/*!--------------------------------------------------------------------------
// <copyright file="GSS.widget.pick_color_tile.js" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/

var GSS = GSS || {};

GSS.messaging = {
    display: function (message)
    {
        var type = message.type;

        if (type == GSS.PortalContainer.portalMessageType.error)
        {
            jQuery.each(message.value, function (index, value) {
                $('.validation-summary-error').append('<span>' + value +'<br/>'+ '</span>')
            });
        }
        if (type == GSS.PortalContainer.portalMessageType.information)
        {
            jQuery.each(message.value, function (index, value) {
                $('.validation-summary-info').append('<span>' +  value +'<br/>'+ '</span>')
            });
        }
        if (type == GSS.PortalContainer.portalMessageType.warning)
        {
            jQuery.each(message.value, function (index, value) {
                $('.validation-summary-warning').append('<span>' + value +'<br/>'+'</span>')
            });
        }
    },
    empty: function (message)
    {
        var type = message.type;

        if (type == GSS.PortalContainer.portalMessageType.error) {
            $('.validation-summary-error').empty();
        }

        if (type == GSS.PortalContainer.portalMessageType.information) {
            $('.validation-summary-info').empty();
        }

        if (type == GSS.PortalContainer.portalMessageType.warning) {
            $('.validation-summary-warning').empty();
        }
    },

    clear: function () {
        $('.validation-summary-error').empty();

        $('.validation-summary-info').empty();

        $('.validation-summary-warning').empty();
    },

    createMessage: function(message)
    {
        var _messageContent = {};
        _messageContent[GSS.PortalContainer.portalMessageFields.type] = GSS.PortalContainer.portalMessageType.error;
        _messageContent[GSS.PortalContainer.portalMessageFields.value] = [message];
        var _message = GSS.PortalContainer.createMessage(null, GSS.PortalContainer.actionNames.portalMessage, _messageContent);

        GSS.PortalContainer.queueMsg(_message);
    }
};